import { gql } from "@apollo/client";

// Every organisation on the caller's profile. The gateway scopes it from the
// token, so there is no transactor filter to pass; callers filter by `type`
// and `deleted_at` locally.
export const ProfileOrganisations = gql`
  query SupplierWeb_ProfileOrganisations {
    profile: profile {
      profile {
        organisations {
          id
          name
          type
          deleted_at
        }
      }
    }
  }
`;
